import { ParquetWorkerClient } from './client';
import { emitParquetMetric, isParquetMetricSinkEnabled } from './instrumentation';

export const parquetWorkerClient = new ParquetWorkerClient({
  metricSink: emitParquetMetric,
  instrumentationEnabled: isParquetMetricSinkEnabled,
});
